import { FolderStatusEnum } from '@koob/enums';

// Accent color per folder status, shared by the kanban columns and the active
// folder card. Hex (not tailwind classes) so consumers can use it for a border
// color and a background at once without a class map per usage.
const FOLDER_STATUS_COLOR = {
  [FolderStatusEnum.NEW]: '#9ca3af',
  [FolderStatusEnum.DRAFT]: '#fbbf24',
  [FolderStatusEnum.CONFIRMING]: '#fb923c',
  [FolderStatusEnum.CONFIRMED]: '#4ade80',
  [FolderStatusEnum.ON_SPOT]: '#60a5fa',
  [FolderStatusEnum.COMPLETED]: '#c084fc',
  [FolderStatusEnum.CANCELLED]: '#f87171',
  [FolderStatusEnum.ARCHIVED]: '#374151',
};

export default function folderStatusColor(status) {
  return (
    FOLDER_STATUS_COLOR[status] ?? FOLDER_STATUS_COLOR[FolderStatusEnum.NEW]
  );
}
